var _rect, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.5C15.2 24.5 11.1 24.3 9.4 23.9C8.7 23.7 8.2 23.2 8 22.5C7.7 21.4 7.5 19.1 7.5 17.5C7.5 15.9 7.7 13.6 8 12.5C8.2 11.8 8.7 11.3 9.4 11.1C11.1 10.7 15.2 10.5 17.5 10.5C19.8 10.5 23.9 10.7 25.6 11.1C26.3 11.3 26.8 11.8 27 12.5C27.3 13.6 27.5 15.9 27.5 17.5C27.5 19.1 27.3 21.4 27 22.5C26.8 23.2 26.3 23.7 25.6 23.9C23.9 24.3 19.8 24.5 17.5 24.5V24.5Z",
    stroke: "#FB8400",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.5L20.5 17.5L15.5 14.5V20.5Z",
    stroke: "#FB8400",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Youtube.c0544ed1.svg";
export { ForwardRef as ReactComponent };